export const PARSE_URL =
  process.env.NODE_ENV === 'development'
    ? // @ts-ignore
      window?.location?.host
      ? `http://${window?.location?.host?.split(':')?.[0]}:8080/parse`
      : 'http://localhost:8080/parse'
    : 'https://www.berriesflow.fr/parse';

export const PARSE_APP_ID =
  process.env.NODE_ENV === 'development' ? 'berriesflow' : 'berriesflow';

export const PARSE_JS_KEY =
  process.env.NODE_ENV === 'development'
    ? 'MEbXqvc5FMUxhsTL3A42PVDdWXEyK38L'
    : 'wuKiURoR3c3VqMGh20KmUFcR2r1GcLh7';
